import React, { Component } from 'react';
import { getTxt } from 'global/appGlobal';
import { withStyles } from '@material-ui/core/styles';
import { withTheme } from '@material-ui/core';

import { Typography } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';



import { Paper } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { AppBar } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import { TextField } from '@material-ui/core';
import { MenuItem } from '@material-ui/core';
import gql from 'graphql-tag';
import { graphql, compose } from 'react-apollo';
import { Tabs, Tab } from '@material-ui/core';
import * as Icon from '@material-ui/icons';
import GridEx from 'components/form/GridEx';

import { Button } from '@material-ui/core';
import moment from 'moment';
import { Badge } from '@material-ui/core';

import ComponentEx from 'components/ComponentEx';
import { queryGetCustomerById, customerBriefQuery, allCustomersQuery } from '../../modules/client/clientQueries';
import c from '../../components/form/Components';
import LinearProgressEx from '../../components/LinearProgressEx';
import { getLabel, DictionaryTypes, getDictionary } from '../../global/dictionaryCache';
import MaterialForm from '../../components/form/MaterialForm';
import MFormText from '../../components/form/MFormText';
import Referent_Search from '../../modules/referent/Referent_Search';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },

    badge: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        marginTop: 0,
    },

    gridRoot: {
        height: '100%',
    },


    formCaption: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
        width: '100%',
        position: 'relative',
        height: 40,
    },
    formCaptionLabel: {
        position: 'absolute',
        //color: theme.palette.primary1,
        backgroundColor: 'transparent',
        left: 25,
        paddingLeft: 10,
        paddingRight: 10,
    },

    rootPaper: theme.mixins.gutters({

        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,// theme.spacing.unit * 3,

    }),

});



class Client_Company_Details_View extends ComponentEx {
    state = {
        value: 0,
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };



    render() {

        if (this.props.quiet) {
            return (<LinearProgressEx loading={this.props.data.loading} />);
        }

        const { classes } = this.props;
        const loading = this.props.data.loading;
        const customer = this.props.data.customer;

        let birth_country_cd;
        let birth_province;
        if (customer) {
            birth_country_cd = this.state.birth_country_cd ? this.state.birth_country_cd : customer.birth_country_cd;
            birth_province = this.state.birth_province ? this.state.birth_province : customer.birth_province;
        }

        let address_country_cd;
        let address_province;
        if (customer) {
            address_country_cd = this.state.address_country_cd ? this.state.address_country_cd : customer.address_country_cd;
            address_province = this.state.address_province ? this.state.address_province : customer.address_province;
        }

        let legal_address_country_cd;
        let legal_address_province;
        if (customer) {
            legal_address_country_cd = this.state.legal_address_country_cd ? this.state.legal_address_country_cd : customer.legal_address_country_cd;
            legal_address_province = this.state.legal_address_province ? this.state.legal_address_province : customer.legal_address_province;
        }

        return (

            <div>
                <LinearProgressEx loading={loading} />
                {!loading &&
                    <MaterialForm dataSource={customer} objType="customer" spacing={12} noFocusOnFirstCtrl >

                        <GridEx item sm={4} xs={12}>
                            <MaterialForm spacing={12} dataSource={customer} objType="customer" noFocusOnFirstCtrl >
                                <c.group l="Dati Compagnia" />
                                <c.readOnlyInLine l="Codice Interno" f="customer_id" />
                                <c.readOnlyInLine l="Ragione sociale" f="company_name" />
                                <c.readOnlyInLine l="Forma giuridica" f="company_reg_type_cd" v={getLabel(DictionaryTypes.CompanyRegType, customer.company_reg_type_cd)} />
                                {customer.broker && <c.readOnlyInLine l="Collaboratore" f="owner_broker_id" v={customer.broker.display_name} />}
                            </MaterialForm>
                        </GridEx>

                        <GridEx item sm={4} xs={12}>
                            <MaterialForm spacing={12} dataSource={customer} objType="customer" noFocusOnFirstCtrl >
                                <c.group l="Sede Legale" />
                                <c.readOnlyInLine l="Nazione" f="legal_address_country_cd" v={getLabel(DictionaryTypes.Country, customer.legal_address_country_cd)} />
                                {legal_address_country_cd === 'IT' &&
                                    <c.readOnlyInLine l={getTxt('Province')} f="legal_address_province" v={getLabel(DictionaryTypes.ItalianProvinces, customer.legal_address_province)} />
                                }
                                <c.readOnlyInLine l="Città" f="legal_address_city" />
                                <c.readOnlyInLine l="CAP" f="legal_address_cap" />
                                <c.readOnlyInLine l="Indirizzo" f="legal_address_street" />
                                <c.readOnlyInLine l="Civico" f="legal_address_street_number" />
                            </MaterialForm>
                        </GridEx>


                        <GridEx item sm={4} xs={12}>
                            <MaterialForm spacing={12} dataSource={customer} objType="customer" noFocusOnFirstCtrl >
                                <c.group l="Sede Operativa" d />

                                <c.readOnlyInLine l="Nazione" f="address_country_cd" v={getLabel(DictionaryTypes.Country, customer.address_country_cd)} d />
                                {address_country_cd === 'IT' &&
                                    <c.readOnlyInLine l={getTxt('Province')} f="address_province" v={getLabel(DictionaryTypes.ItalianProvinces, customer.address_province)} d />
                                }
                                <c.readOnlyInLine l="Città" f="address_city" d />
                                <c.readOnlyInLine l="CAP" f="address_cap" d />
                                <c.readOnlyInLine l="Indirizzo" f="address_street" d />
                                <c.readOnlyInLine l="Civico" f="address_street_number" d />
                            </MaterialForm>
                        </GridEx>




                        <GridEx item sm={4} xs={12}>
                            <MaterialForm spacing={12} dataSource={customer} objType="customer" noFocusOnFirstCtrl >
                                <c.group l="Informazioni Contatti" d />
                                <c.readOnlyInLine l="Telefono" f="phone" d />
                                <c.readOnlyInLine l="Telefono Attività" f="phone_active" d />
                                <c.readOnlyInLine l="Cellulare" f="mobile_phone" d />
                                <c.readOnlyInLine l="Email" f="email" d />
                                <c.readOnlyInLine l="PEC" f="email_pec" d />
                            </MaterialForm>
                        </GridEx>



                        <GridEx item sm={6} xs={12}>
                            <MaterialForm spacing={12} dataSource={customer} objType="customer" noFocusOnFirstCtrl >
                                <c.group l="Informazioni Aggiuntive" d />
                                <GridEx item sm={6} xs={12}>
                                    <MaterialForm spacing={12} dataSource={customer} objType="customer" >
                                        <c.readOnlyInLine l="Codice Fiscale" f="fiscal_code" d />
                                        <c.readOnlyInLine l="Partita iva" f="vat_number" d />
                                        <c.readOnlyInLine l="IBAN" f="bank_iban" d />

                                        <c.readOnlyInLine l="Attività Svolta" f="business_occupation" v={getLabel(DictionaryTypes.BusinessOccupation, customer.business_occupation)} d />

                                        <c.readOnlyInLine l="ritenuta" f="considered_percent" d />
                                        <c.readOnlyInLine l="cod. ipa Fatt. Eletti." f="vat_descr" d />


                                    </MaterialForm>
                                </GridEx>
                                <GridEx item sm={6} xs={12}>
                                    <MaterialForm spacing={12} dataSource={customer} objType="customer" noFocusOnFirstCtrl >

                                        <c.readOnlyInLine l="Numero iscrizione camera commercio" f="company_reg_number" d />
                                        <c.readOnlyInLine l="Data iscrizione" f="company_registration_date" d />

                                        <c.readOnlyInLine l="Numero di dipendenti dell'azienda" f="company_employee_number" d />
                                        <c.readOnlyInLine l="Fatturato, EUR" f="company_revenue_eur" d />
                                        <c.readOnlyInLine f="trusted_amount" />


                                        <c.readOnlyInLine l={getTxt('Communication Agree')} f="communication_agree" d />
                                        <c.readOnlyInLine l="Non inviare comunicazioni automatiche" f="communication_unsubscribed" d />
                                    </MaterialForm>
                                </GridEx>

                                <c.group l={getTxt('Notes')} d />
                                <GridEx item sm={12} xs={12}>
                                    <MaterialForm spacing={12} dataSource={customer} objType="customer" >
                                        <c.readOnlyInLine l="" f="internal_notes" d />
                                    </MaterialForm>
                                </GridEx>

                            </MaterialForm>
                        </GridEx>

                        <GridEx item sm={12} xs={12}>
                            <MaterialForm spacing={2} dataSource={customer} objType="customer" noFocusOnFirstCtrl >
                                {customer && <Referent_Search parentId={customer.customer_id} history={this.props.history} />}
                            </MaterialForm>
                        </GridEx>

                    </MaterialForm>


                }

            </div>

        );
    }
}

export default graphql(queryGetCustomerById,
    {
        options: props => ({
            variables: { id: props.customerId },
            fetchPolicy: 'network-only',
            options: {
                errorPolicy: 'all',
            },
        }),
    })(withStyles(styles, true)(Client_Company_Details_View));

